<template>
  <div class="content-heading">
    <i class="ic-head-icon" aria-hidden="true">
      <img src="@/assets/images/sidebar/rewards.svg" alt="Rewards Icon" />
    </i>
    <h4 class="head-title">Stores</h4>
    <i class="ic-tooltip" id="help" aria-hidden="true"></i>
    <b-popover
      target="help"
      triggers="hover"
      content="Set the list of your store branches and employees in this section."
    >
    </b-popover>
    <div class="head-tabs">
      <AppTabs :tabs="tabs" />
    </div>
  </div>
</template>

<script>
import permission from "../../services/user.permission";
import AppTabs from "@/components/common/AppTabs.vue";
export default {
  name: "store-nav",
  components: { AppTabs },
  data() {
    return {
      msg: "Store Nav",
      permission: permission,
      tabs: [
        {
            name: permission.getSubmoduleName(
              "store.organization"
            ),
            href: "/store/organization",
            access: "store.organization"
        },
        {
            name: permission.getSubmoduleName(
              "store.employee"
            ),
            href: "/store/employee",
            access: "store.employee"
        },
        {
            name: permission.getSubmoduleName(
              "store.table_ordering:topup-table_ordering"
            ),
            href: { name: 'StoreDineIn' },
            access: "store.table_ordering:topup-table_ordering"
        }
      ]
    };
  },
};
</script>
